var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLoading = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm5-1.414L18.414 17A1 1 0 0 1 17 18.414L15.586 17A1 1 0 0 1 17 15.586zm-10 0A1 1 0 1 1 8.414 17L7 18.414A1 1 0 1 1 5.586 17zM20 11a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2h2zM6 11a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2h2zm1-5.414L8.414 7A1 1 0 0 1 7 8.414L5.586 7A1 1 0 0 1 7 5.586zm10 0A1 1 0 0 1 18.414 7L17 8.414A1 1 0 0 1 15.586 7zM12 3a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V4a1 1 0 0 1 1-1z",
    fill: "#262626",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLoading);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-loading.bc639e787e1b46823b0b874952cf48e8.svg";